exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".logo{\n  overflow: hidden;\n  margin: 16px;\n}\n\ntd.column-word-wrap1 {\n  word-break: break-all;\n}\n\n.column-word-ellipsis1 {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.button-block {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  grid-gap: 8px;\n}", ""]);

